// @flow

import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import localforage from 'localforage';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';
import mapSeries from 'async/mapSeries';
import _ from 'lodash';
import $ from 'jquery';
import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary} from 'material-ui-next/ExpansionPanel';

// NOTE: cuando pongo un expandIcon={<ExpandMoreIcon />} en los ExpansionPanelSummary, salen warnings super feos:
// import ExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more.js';

import App from './App.jsx';

import {ROLES_DIFF_MAP, USERS_CR} from './consts.js';
import {EMPTY_SUM} from './Shp.js';
import {takeFilename, takeDir, noop, get_predio, is_bio_or_photo, service_is, png_is, fixslash} from './utils.js';
import {fetch_dir, get_all_services, get_ms_of_dir} from './fetch_things.js';

import type {T_ResultMeasure, T_Next, T_Png_Culti, T_Node} from './types.js';
import type {T_ShpFile} from './Shp.js';

import './css/DialogTools.css';


type T_DialogToolsProps = {
  app                  : App,
  showing_thematic     : boolean,
  showing_mav          : boolean,
  showing_diff         : boolean,
  four_maps            : boolean,
  fix_zoom             : boolean,
  result               : T_ResultMeasure,
  height               : number,
  use_pixel_tool       : boolean,
  can_admin_users      : boolean,
  num_decimals         : number,
  open_last            : boolean,
  change_culti_on_close: boolean
};



type T_Box = 'MEDIDAS' | 'POST_PROCESO' | 'VISUALES' | 'ADMIN' | '';



type T_DialogToolsState = {
  which_measure  : string,
  can_toggle_four: boolean,
  expanded       : T_Box,
  top            : number,
  current_ms_path: string
};



export default class DialogTools extends Component<T_DialogToolsProps, T_DialogToolsState> {
  change_measure_tool_none    : (ev: SyntheticEvent<*>) => void;
  change_measure_tool_pixel   : (ev: SyntheticEvent<*>) => void;
  change_measure_tool_coord   : (ev: SyntheticEvent<*>) => void;
  change_measure_tool_dist    : (ev: SyntheticEvent<*>) => void;
  change_measure_tool_area    : (ev: SyntheticEvent<*>) => void;
  change_measure_tool_sum     : (ev: SyntheticEvent<*>) => void;
  change_num_decimals         : (ev: SyntheticInputEvent<*>) => void;
  mav_ui                      : () => void;
  join_ui                     : () => void;
  toggle_four_maps            : () => void;
  toggle_open_last            : () => void;
  toggle_change_culti_on_close: () => void;
  open_post_proceso           : () => void;
  open_medidas                : () => void;
  open_visuales               : () => void;
  open_user_admin             : () => void;
  new_user                    : () => void;
  edit_users                  : () => void;
  new_login                   : () => void;
  
  
  
  constructor(props: T_DialogToolsProps) {
    super(props);
    
    this.state = {
      which_measure  : 'none',
      can_toggle_four: true,
      expanded       : '',         // o 'POST_PROCESO', si queremos abrir el primero por defecto.
      top            : 100,
      current_ms_path: ''
    };
    
    this.change_measure_tool_none     = this.change_measure_tool_none.bind(this);
    this.change_measure_tool_pixel    = this.change_measure_tool_pixel.bind(this);
    this.change_measure_tool_coord    = this.change_measure_tool_coord.bind(this);
    this.change_measure_tool_dist     = this.change_measure_tool_dist.bind(this);
    this.change_measure_tool_area     = this.change_measure_tool_area.bind(this);
    this.change_measure_tool_sum      = this.change_measure_tool_sum.bind(this);
    this.mav_ui                       = this.mav_ui.bind(this);
    this.join_ui                      = this.join_ui.bind(this);
    this.toggle_four_maps             = this.toggle_four_maps.bind(this);
    this.toggle_open_last             = this.toggle_open_last.bind(this);
    this.toggle_change_culti_on_close = this.toggle_change_culti_on_close.bind(this);
    this.open_post_proceso            = this.open_post_proceso.bind(this);
    this.open_medidas                 = this.open_medidas.bind(this);
    this.open_visuales                = this.open_visuales.bind(this);
    this.open_user_admin              = this.open_user_admin.bind(this);
    this.new_user                     = this.new_user.bind(this);
    this.edit_users                   = this.edit_users.bind(this);
    this.new_login                    = this.new_login.bind(this);
    this.change_num_decimals          = this.change_num_decimals.bind(this);
    
    this.props.app.dialog_tools = this;
  }
  
  
  
  componentDidMount() {
    this.set_position();
  }
  
  
  
  componentDidUpdate(prevProps: T_DialogToolsProps, prevState: T_DialogToolsState) {
    const {app} = this.props;
    
    if ((prevState.which_measure === 'sum' && this.state.which_measure !== 'sum') ||
        (prevState.which_measure !== 'sum' && this.state.which_measure === 'sum')) {
      this.clean_sum_shp(this.props.app.map_ui.map.last_culti_path());
    }
    
    if (prevState.which_measure === 'pixel' && this.state.which_measure !== 'pixel' && app.medidas != null) {
      app.medidas.clean_pixel_tool();
      
      if (app.medidas != null && this.state.which_measure !== 'coord' && this.state.which_measure !== 'dist' &&
          this.state.which_measure !== 'area') {
        app.medidas.j_stop.click();
      }
    }
    
    if (prevState.which_measure === 'coord' && this.state.which_measure !== 'coord' && this.state.which_measure !== 'pixel' &&
        this.state.which_measure !== 'dist' && this.state.which_measure !== 'area' && app.medidas != null) {
      app.medidas.j_stop.click();
    }
    
    if ((prevState.which_measure === 'area' || prevState.which_measure === 'dist') &&
        this.state.which_measure === 'sum' && app.medidas != null) {
      app.medidas.j_stop.click();
    }
    
    if (prevState.which_measure !== this.state.which_measure && app.medidas != null) {
      app.medidas.clean_tool(true);
    }
    
    if (this.props.height !== prevProps.height) {
      this.set_position();
    }
    
    if (this.state.expanded === 'POST_PROCESO' && prevState.expanded !== 'POST_PROCESO' && app.toolbar != null) {
      get_ms_of_dir(app, takeDir(app.toolbar.state.culti), (result: T_ShpFile | string) => {
        if (typeof result !== 'string' && app.state.show_dialog_tools) {
          this.setState({current_ms_path: result.shpfile});
        }
      });
    }
  }
  
  
  
  clean_sum_shp(path: string): void {
    if (! path) {
      return;
    }
    
    const {app} = this.props;
    
    if (_.has(app.map_ui.map.Shp_List, path) && app.map_ui.map.Shp_List[path] != null) {
      const shp = app.map_ui.map.Shp_List[path];
      
      if (shp.sum_areas.ids.length > 0) {
        app.map_ui.setState({dbf: null});
      }
      
      shp.sum_areas = _.cloneDeep(EMPTY_SUM);
      
      shp.reset_hilight();
    }
  }
  
  
  
  componentWillUnmount() {
    const {app} = this.props;
    
    app.dialog_tools = null;
    
    if (app.medidas != null) {
      if (app.medidas.j_stop != null) {
        app.medidas.j_stop.click();
      }
    }
    
    this.clean_sum_shp(app.map_ui.map.last_culti_path());
  }
  
  
  
  reset_output() {
    this.props.app.setState({
      result_measure: {kind1: 'none', result1: '', kind2: 'none', result2: ''}
    });
  }
  
  
  
  change_num_decimals(ev: SyntheticInputEvent<*>): void {
    const num_decimals = parseInt(ev.target.value, 10),
          {app} = this.props;
    
    localforage.setItem(`${app.state.user.user_name}.num_decimals`, num_decimals).then(() => {
      app.setState({num_decimals});
    });
  }
  
  
  
  change_measure_tool(who: string): void {
    if (this.props.app.medidas != null) {
      const {medidas} = this.props.app;      
      if (who === 'none') {
        medidas.j_stop.click();
        
        this.reset_output();
      }
      else if (who === 'pixel' || who === 'coord') {
        medidas.j_coord.click();
        
        this.reset_output();
      }
      else if (who === 'dist') {
        medidas.j_dist.click();
        
        this.reset_output();
      }
      else if (who === 'area') {
        medidas.j_area.click();
        
        this.reset_output();
      }
      else if (who === 'sum') {
        // do nothing.
      }
    }
    
    this.setState({which_measure: who});
  }
  
  
  
  change_measure_tool_none(): void {
    this.change_measure_tool('none');
  }
  
  
  
  change_measure_tool_pixel(): void {
    this.change_measure_tool('pixel');
  }
  
  
  
  change_measure_tool_coord(): void {
    this.change_measure_tool('coord');
  }
  
  
  
  change_measure_tool_dist(): void {
    this.change_measure_tool('dist');
  }
  
  
  
  change_measure_tool_area(): void {
    this.change_measure_tool('area');
  }
  
  
  
  change_measure_tool_sum(): void {
    this.change_measure_tool('sum');
  }
  
  
  
  no_mav(next: T_Next): void {
    const {app} = this.props;
    
    if (app.map_ui.state.show_mav && app.map_ui.state.escala_for != null) {
      app.map_ui.toggle_mav(next);
    }
    else if (app.map_ui.state.zombie_mav) {
      app.map_ui.setState({zombie_mav: null}, () => {
        app.setState({showing_mav: false});
      });
    }
    else {
      next(true);
    }
  }
  
  
  
  mav_ui(): void {
    this.no_join(() => {
      const {app} = this.props,
            shp_path = app.map_ui.map.last_shp_path();
      
      app.bar.renew_escala(() => {
        app.map_ui.renew_escala(() => {
          if (app.map_ui.state.zombie_mav != null) {
            this.no_mav(noop);
          }
          else if (takeFilename(shp_path).indexOf('cultivable_') === 0) {
            const item_png = app.get_opened_image_of(takeDir(shp_path));
            
            if (item_png != null) {
              app.map_ui.toggle_mav();
            }
            else {
              Alert.error('Abra una imagen para crear un Mav.');
            }
          }
          else {
            Alert.error('Abra un cultivable para crear un Mav.');
          }
        });
      });
    });
  }
  
  
  
  no_join(next: T_Next): void {
    if (this.props.app.state.show_dialog_thematic) {
      this.props.app.setState({show_dialog_thematic: false}, () => {
        next(true);
      });
    }
    else {
      next(true);
    }
  }
  
  
  
  join_ui(): void {
    const {app} = this.props,
          path  = app.map_ui.map.last_culti_path();
    
    if (! path) {
      return Alert.error('Seleccione un cultivable para crear un mapa temático.');
    }
    
    app.setState({wait: true}, () => {
      this.no_mav(() => {
        if (app.state.four_maps) {
          app.setState({symmetric_four_maps: false}, () => {
            app.map_ui.fix_resize();
            
            if (app.four_maps != null) {
              app.four_maps.center_all(path, noop);
            }
          });
        }
        else {
          for (let num = 0; num < 4; num += 1) {
            app.is_ready[`Map${num}`] = false;
          }
          
          app.toggle_four_maps(false);    // app.ready se va a encargar de modificar app.state.show_dialog_thematic
        }
      });
      
      app.setState({show_dialog_tools: false}, () => {
        if (app.sidebar != null) {
          app.sidebar.setState({bt_active: ''});
        }
      });
    });
  }
  
  
  
  diff_ui = (): void => {
    const {app} = this.props;
    
    if (app.state.bios.length > 0)
      return app.setState({bios: []});
    
    if (app.toolbar != null) {
      const {toolbar} = app;
      
      if (toolbar.props.current_map != null && is_bio_or_photo(toolbar.props.current_map)) {
        const prefix = png_is('biosense', toolbar.props.current_map) ? 'biosense' : 'ndvi';
        
        get_all_services(app, get_predio(toolbar.state.culti), (cultis: Array<string>) => {
          mapSeries(cultis.filter(path => service_is(prefix, path)), (culti_path, callback) => {
            fetch_dir(app, takeDir(culti_path), (result: Array<T_Node> | string) => {
              if (typeof result === 'string') {
                callback(true, null);
              }
              else if (result instanceof Array) {
                callback(null, result.find(node => node.Type === 'png' && png_is(prefix, node.Path)));
              }
            });
          }, (err, rs: Array<?T_Node>) => {
            const pngs = _.compact(rs).map(node => node.Path);
            pngs.sort();
            
            const make_pair = (png: string): T_Png_Culti => {
              return {png, culti: (cultis.find(culti => takeDir(culti) === takeDir(png)) || '')};
            };
            
            app.setState({show_dialog_tools: false, bios: pngs.map(make_pair)});
          });
        });
      }
      else {
        Alert.error('Seleccione un mapa de biosense o un ndvi para crear un MD.');
      }
    }
    else {
      Alert.error('Seleccione un mapa de biosense o un ndvi para crear un MD.');
    }
  };
  
  
  
  toggle_open_last(): void {
    const {app} = this.props;
    
    app.setState({open_last: ! app.state.open_last}, () => {
      localforage.setItem(`${app.state.user.user_name}.open_last`, app.state.open_last);
    });
  }
  
  
  
  toggle_change_culti_on_close(): void {
    const {app} = this.props;
    
    app.setState({change_culti_on_close: ! app.state.change_culti_on_close}, () => {
      localforage.setItem(`${app.state.user.user_name}.change_culti_on_close`, app.state.change_culti_on_close);
    });
  }
  
  
  
  toggle_four_maps(): void {
    const {app} = this.props;
    
    if (this.props.four_maps && app.four_maps != null) {
      const {four_maps} = app;
      
      this.setState({can_toggle_four: false}, () => {
        const {symmetric} = four_maps.props;
        
        const Close = (next) => {
          if (symmetric) {
            app.toggle_four_maps(true, next);
          }
          else {
            app.close_mt_view(next);
          }
        };
        
        Close(() => {
          if (app.tree != null) {
            app.tree.unclick_all();
          }
          
          _.delay(() => {
            const timer = setInterval(() => {
              if (app.medidas != null) {
                clearInterval(timer);
                
                if (app.state.show_dialog_tools) {
                  this.setState({can_toggle_four: true});
                }
              }
            }, 200);
          }, 1200);
        });
      });
    }
    else {
      this.setState({can_toggle_four: false}, () => {
        app.toggle_four_maps(true, () => {
          _.delay(() => {
            if (app.state.show_dialog_tools) {
              this.setState({can_toggle_four: true});
            }
          }, 1200);
        });
      });
    }
  }
  
  
  
  set_position(): void {
    const bt_tools = $('#sidebt_tools');
    
    if (bt_tools.length) {
      this.setState({
        top: bt_tools.position().top - 50
      });
    }
  }
  
  
  
  csv_climasense_cooprinsem = (): void => {
    this.props.app.setState({show_dialog_tools: false, ui_clima_cooprinsem: true});
    this.props.app.sidebar.setState({bt_active: ''});
  };
  
  
  
  
  // ESTA FUNCIÓN DETERMINA SI EL USUARIO ACTUAL PUEDE USAR LA CENTRAL DE RECOMENDACIÓN:
  
  user_canuse_cr(): boolean {
    const {app} = this.props;
    
    return app.agrosat_user || USERS_CR.includes(app.state.user.user_name);
  }
  
  
  
  // ESTA FUNCIÓN DETERMINA SI EL SERVICIO ACTUAL ES APTO PARA LA CENTRAL DE RECOMENDACIÓN:
  
  cr_available(): boolean {    
    const {app} = this.props;
    
    if (app.toolbar != null) {
      const
        {toolbar} = app,
        {culti} = toolbar.state,
        es_tematico = toolbar.props.current_map != null && takeFilename(toolbar.props.current_map).indexOf('Mapa_Tematico_') === 0;
      
      if (es_tematico || ! culti)
        return false;
      
      const
        item_dir     = app.get_item_dir(fixslash(takeDir(culti))),
        item_ms      = item_dir == null ? null : item_dir.get_ms(),
        service_name = app.guess_service_name(culti, item_ms);
      
      if ((! item_ms) && (! app.agrosat_user) && this.state.current_ms_path !== '' && service_name === 'sin_servicio') {
        if (takeDir(culti) === takeDir(this.state.current_ms_path)) {
          return takeFilename(this.state.current_ms_path).startsWith('ms_');
        }
      }
      
      return item_dir != null && service_name === 'nutricheck_suelo';
    }
    
    return false;
  }
  
  
  
  show_central_fert = (): void => {
    if (this.props.app.toolbar != null) {
      this.props.app.toolbar.show_central_fert();
    }
  }
  
  
  
  render_post_proceso(marginTop: number) {
    const {app} = this.props;
    
    return (
      <div className='create_box' style={{marginTop}}>
        <div>
          <RaisedButton
            label='Mapa Temático (MT)'
            onClick={this.join_ui}
            primary={this.props.showing_thematic}
            icon={<i className='fa fa-map' />}
          />
        </div>
        
        <div>
          <RaisedButton
            label='Mapa de Aplicación Variable (MAV)'
            onClick={this.mav_ui}
            primary={this.props.showing_mav}
            icon={<i className='fa fa-pie-chart' />}
          />
        </div>
        
        {(app.agrosat_user || ROLES_DIFF_MAP.includes(app.state.user.role)) &&
          <div>
            <RaisedButton
              label='Mapa Diferencial (MD)'
              onClick={this.diff_ui}
              primary={this.props.showing_diff}
              icon={<i className='fa fa-search-minus' />}
            />
          </div>
        }
        
        {(app.agrosat_user && app.dev_mode) &&
          <div>
            <RaisedButton
              label='Reporte climasense cooprinsem'
              onClick={this.csv_climasense_cooprinsem}
              icon={<i className='fa fa-tint' />}
            />
          </div>
        }
        
        {(this.user_canuse_cr() && this.cr_available()) &&
          <RaisedButton
            icon={<img src='img/icon_CR.png' alt='' />}
            label='Central de Fertilización'
            onClick={this.show_central_fert}
          />
        }
      </div>
    );
  }
  
  
  
  render_medidas(which: string, result: string, marginTop: number) {
    return (
      <div className='medidas_box' style={{marginTop}}>
        <div className='medidas_box_radios'>
          <input type='radio' name='M3D' id='rb_area' checked={which === 'area'} onChange={this.change_measure_tool_area} />
          <label htmlFor='rb_area'>Área</label><br />
          
          <input type='radio' name='M3D' id='rb_dist' checked={which === 'dist'} onChange={this.change_measure_tool_dist} />
          <label htmlFor='rb_dist'>Distancia</label><br />
          
          <input type='radio' name='M3D' id='rb_coord' checked={which === 'coord'} onChange={this.change_measure_tool_coord} />
          <label htmlFor='rb_coord'>Coordenada</label><br />
          
          {this.props.use_pixel_tool &&
            <div>
              <input type='radio' name='M3D' id='rb_pixel' checked={which === 'pixel'} onChange={this.change_measure_tool_pixel} />
              <label htmlFor='rb_pixel'>Valor del elemento</label><br />
            </div>
          }
          
          <input type='radio' name='M3D' id='rb_sum' checked={which === 'sum'} onChange={this.change_measure_tool_sum} />
          <label htmlFor='rb_sum'>Sumar áreas</label><br />
          
          <input type='radio' name='M3D' id='rb_none' checked={which === 'none'} onChange={this.change_measure_tool_none} />
          <label htmlFor='rb_none'>Ninguna</label><br />
        </div>
        
        {(result !== '') &&
          <div className='medidas_result'>
            <center>
              {result}
            </center>
          </div>
        }
      </div>
    );
  }
  
  
  
  render_visuales(marginTop: number) {
    return (
      <div className='visual_box' style={{marginTop}}>
        <div>
          <Toggle
            label='Dividir pantalla'
            labelPosition='right'
            toggled={this.props.four_maps}
            onToggle={this.toggle_four_maps}
            disabled={! this.state.can_toggle_four}
          />
        </div>
          
        <div>
          <Toggle
            label='Fijar zoom'
            labelPosition='right'
            toggled={this.props.fix_zoom}
            onToggle={this.props.app.toggle_fix_zoom}
          />
        </div>
        
        <div>
          <Toggle
            label='Abrir último cultivable'
            labelPosition='right'
            toggled={this.props.open_last}
            onToggle={this.toggle_open_last}
          />
        </div>
        
        <div>
          <Toggle
            label='Cambiar al último cultivable al cerrar'
            labelPosition='right'
            toggled={this.props.change_culti_on_close}
            onToggle={this.toggle_change_culti_on_close}
          />
        </div>
        
        <div className='num_decs'>
          Número de decimales:
          <input type='number' min={1} max={5} value={this.props.num_decimals} onChange={this.change_num_decimals} />
        </div>
      </div>
    );
  }
  
  
  
  new_user(): void {
    const {app} = this.props;
    
    if (this.props.can_admin_users && ! app.state.show_dialog_user_create) {
      const open_it = () => {
        const new_state = {
          show_menu_user         : false,
          show_tree              : false,
          show_dialog_user_create: true,
          edit_users             : [],
          show_dialog_tools      : false
        };
        
        app.map_ui.fix_resize();
        
        app.setState(new_state, () => {
          app.map_ui.setState({dbf: null});
          
          app.sidebar.setState({bt_active: ''});
        });
      };
      
      open_it();
    }
  }
  
  
  
  edit_users(): void {
    const {app} = this.props;
    
    if (app.state.edit_users.length === 0 && this.props.can_admin_users && ! app.state.show_dialog_user_create) {
      app.set_edit_users();
    }
  }
  
  
  
  new_login(): void {
    window.open(`${window.location.href}?new_login`, '_blank');
  }
  
  
  
  render_user_admin(marginTop: number) {
    return (
      <div className='create_box' style={{marginTop}}>
        <div>
          <RaisedButton
            label='Crear nuevo usuario'
            onClick={this.new_user}
            primary={false}
            icon={<i className='fa fa-user-plus fa-lg' />}
          />
        </div>
        <div>
          <RaisedButton
            label='Editar usuario'
            onClick={this.edit_users}
            primary={false}
            icon={<i className='fa fa-edit fa-lg' />}
          />
        </div>
        
        <div>
          <RaisedButton
            label='Probar otro usuario'
            onClick={this.new_login}
            primary={false}
            icon={<i className='fa fa-user-secret fa-lg' />}
          />
        </div>
      </div>
    );
  }
  
  
  
  toggle(box_name: T_Box): void {
    this.setState({
      expanded: (this.state.expanded === box_name ? '' : box_name)
    });
  }
  
  
  
  open_post_proceso(): void {
    this.toggle('POST_PROCESO');
  }
  
  
  
  open_medidas(): void {
    this.toggle('MEDIDAS');
  }
  
  
  
  open_visuales(): void {
    this.toggle('VISUALES');
  }
  
  
  
  open_user_admin(): void {
    this.toggle('ADMIN');
  }
  
  
  
  render() {
    const which = this.state.which_measure,
          {expanded} = this.state,
          main_style = {
            top: this.state.top,
            width: 320,
            padding: 0,
            borderRadius: 0,
            border: 0,
            backgroundColor: 'transparent'
          };
    
    let result = '';
    
    if (this.props.result.kind1 !== 'none' && this.props.result.result1 !== '' && this.props.result.kind1 === which) {
      result = this.props.result.result1;
    }
    else if (this.props.result.kind2 !== 'none' && this.props.result.result2 !== '' && this.props.result.kind2 === which) {
      result = this.props.result.result2;
    }
    
    return (
      <div className='dialog_tools' style={main_style}>
        <ExpansionPanel expanded={expanded === 'POST_PROCESO'} onChange={this.open_post_proceso}>
          <ExpansionPanelSummary expandIcon={<Icon name='angle-down' size='lg' />}>
            <span className='box_title' style={{fontWeight: (expanded === 'POST_PROCESO' ? 'bold' : 'normal')}}>
              Post proceso
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {this.render_post_proceso(0)}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        
        <ExpansionPanel expanded={expanded === 'MEDIDAS'} onChange={this.open_medidas}>
          <ExpansionPanelSummary expandIcon={<Icon name='angle-down' size='lg' />}>
            <span className='box_title' style={{fontWeight: (expanded === 'MEDIDAS' ? 'bold' : 'normal')}}>
              Medidas
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {this.render_medidas(which, result, 0)}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        
        <ExpansionPanel expanded={expanded === 'VISUALES'} onChange={this.open_visuales}>
          <ExpansionPanelSummary expandIcon={<Icon name='angle-down' size='lg' />}>
            <span className='box_title' style={{fontWeight: (expanded === 'VISUALES' ? 'bold' : 'normal')}}>
              Visuales
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            {this.render_visuales(0)}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        
        {this.props.can_admin_users &&
          <ExpansionPanel expanded={expanded === 'ADMIN'} onChange={this.open_user_admin}>
            <ExpansionPanelSummary expandIcon={<Icon name='angle-down' size='lg' />}>
              <span className='box_title' style={{fontWeight: (expanded === 'ADMIN' ? 'bold' : 'normal')}}>
                Usuarios
              </span>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {this.render_user_admin(0)}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DialogTools.jsx